module.exports = __webpack_public_path__ + "static/media/060.26594dfc.jpg";